import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const categoryColors: Record<string, string> = {
  core: 'bg-orange-100 text-orange-700',
  support: 'bg-green-100 text-green-700',
  longtail: 'bg-sky-100 text-sky-700',
};

const ArticleGrid = () => {
  const featured = articles.slice(0, 6);
  const rest = articles.slice(6, 12);

  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-2">Latest Coupon Guides</h2>
            <p className="text-gray-500">Expert guides on joyagoo coupons, spreadsheets, and shopping tips</p>
          </div>
          <Link
            to="/joyagoo-coupon-code"
            className="flex items-center gap-1.5 text-orange-500 font-semibold text-sm hover:text-orange-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All Articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Featured 6 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <span className={`absolute top-3 right-3 text-xs font-semibold px-2.5 py-1 rounded-full ${categoryColors[article.category]}`}>
                  {article.categoryLabel}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base leading-snug mb-2 line-clamp-2 group-hover:text-orange-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-gray-500 line-clamp-2 mb-4 leading-relaxed">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-gray-400">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Next 6 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {rest.map((article) => (
            <Link
              key={article.id}
              to={`/${article.slug}`}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:-translate-y-1 transition-all duration-300 cursor-pointer flex gap-4 p-4"
            >
              <div className="w-24 h-20 flex-shrink-0 rounded-xl overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${categoryColors[article.category]}`}>
                  {article.categoryLabel}
                </span>
                <h3 className="font-bold text-gray-900 text-sm leading-snug mt-1.5 mb-1 line-clamp-2 group-hover:text-orange-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-gray-400">{article.date} · {article.readTime}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/joyagoo-coupon-2026"
            className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-orange-500 text-orange-500 font-bold rounded-xl hover:bg-orange-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            View All 20 Articles
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ArticleGrid;
